import {
  LayoutDashboard,
  Users,
  FolderOpen,
  CheckSquare,
  Shield,
  History,
  DollarSign,
  BarChart3,
  Settings,
  Receipt,
  Calculator,
  Bell,
  FileText,
  Calendar,
  Menu,
  FileCheck2,
  CircleHelp,
} from 'lucide-react'
import type { NavigationItem } from '../types/workspace'

// ==========================================
// Single source of truth for all navigation
// ==========================================

// Inicio queda suelto arriba del sidebar (ORR-192).
export const CORE_NAVIGATION: NavigationItem[] = [
  { id: 'dashboard', name: 'Inicio', href: '/', icon: LayoutDashboard },
]

// Grupo "Clientes" del sidebar (ORR-192): gestión de clientes.
export const CLIENTES_NAV: NavigationItem[] = [
  { id: 'clientes', name: 'Clientes', href: '/clientes', icon: Users, permission: 'verClientes' },
  { id: 'documentos', name: 'Documentos', href: '/documentos', icon: FolderOpen, permission: 'verDocumentos' },
  { id: 'tareas', name: 'Tareas', href: '/tareas', icon: CheckSquare, permission: 'verTareas' },
]

// Sección "Administración" (ORR-192): Reportes se gobierna por verReportes (no por esAdmin);
// DynamicSidebar filtra esta lista por permiso efectivo y muestra la sección si quedan items.
export const ADMIN_NAVIGATION: NavigationItem[] = [
  { id: 'reportes', name: 'Reportes', href: '/reportes', icon: BarChart3, permission: 'verReportes' },
  { id: 'usuarios', name: 'Usuarios', href: '/usuarios', icon: Shield, permission: 'gestionarUsuarios' },
  { id: 'auditoria', name: 'Auditoria', href: '/auditoria', icon: History, permission: 'verAuditoria' },
]

// Items in the "Mas" menu on mobile (not in bottom tabs or core)
export const MOBILE_MENU_ITEMS: NavigationItem[] = [
  { id: 'clientes', name: 'Clientes', href: '/clientes', icon: Users },
  { id: 'movimientos', name: 'Movimientos', href: '/movimientos', icon: DollarSign, permission: 'verMovimientos' },
  { id: 'servicios', name: 'Servicios', href: '/servicios', icon: Receipt },
  { id: 'cuentas', name: 'Cuentas', href: '/cuentas', icon: Calculator },
  { id: 'impuestos', name: 'Impuestos', href: '/impuestos', icon: FileText },
  { id: 'presupuestos', name: 'Presupuestos', href: '/presupuestos', icon: FileText },
  { id: 'facturas', name: 'Facturas', href: '/facturas', icon: FileCheck2, permission: 'verFacturas' },
  { id: 'reportes', name: 'Reportes', href: '/reportes', icon: BarChart3 },
  { id: 'notificaciones', name: 'Notificaciones', href: '/notificaciones', icon: Bell },
  { id: 'ayuda', name: 'Ayuda', href: '/ayuda', icon: CircleHelp },
]

export const MOBILE_ADMIN_ITEMS: NavigationItem[] = [
  { id: 'usuarios', name: 'Usuarios', href: '/usuarios', icon: Shield },
  { id: 'auditoria', name: 'Auditoria', href: '/auditoria', icon: History },
  { id: 'configuracion', name: 'Configuracion', href: '/configuracion', icon: Settings },
]

// Bottom tab bar items (subset of core + "Mas")
export const BOTTOM_TABS = [
  { id: 'dashboard', name: 'Inicio', href: '/', icon: LayoutDashboard },
  { id: 'tareas', name: 'Tareas', href: '/tareas', icon: CheckSquare },
  { id: 'calendario', name: 'Calendario', href: '/calendario', icon: Calendar },
  { id: 'documentos', name: 'Docs', href: '/documentos', icon: FolderOpen },
  { id: 'mas', name: 'Mas', href: '#', icon: Menu },
] as const

// Layout constants
export const MOBILE_NAV_HEIGHT = 'h-16'
export const MOBILE_NAV_PADDING = 'pb-16'
